module.exports = __webpack_public_path__ + "static/media/swapna_khare.a5281aeb.png";